(function() {
    'use strict';
    Odigeo.UIElements.enhanceExpandable = function(details, config, showCallback) {
        var ATTR_OPEN = 'open';
        var $expandableAreaDivTag = null;
        var options = {
            enabled: true,
            selfClose: true,
        };
        var properties = null;
        var $el = null;
        var isSummaryTagPresent = false;
        var $summaryElement;
        var $rootWrapperDiv;
        var $toggleAreaDivWrapper;

        Odigeo._.extend(options, config);

        if (!Odigeo._.isUndefined(details.length) && details.length > 1) {
            $el = (details[0] instanceof $) ? details[0] : $(details[0]);
        } else {
            $el = (details instanceof $) ? details : $(details);
        }

        // Checking whether this UI Element has already been enhanced
        if (!Odigeo._.isUndefined($el.attr('data-skip-enhance')) && $el.attr('data-skip-enhance').toUpperCase() === 'true'.toUpperCase()) {
            return;
        }

        // Incoming element 'details' validation
        if (Odigeo._.isEmpty($el) || $el.length < 1) {
            throw new Error('Youre trying to apply expandable enhancement to a wrong element,' +
                ' just details elements are allowed.');
        } else if ($el[0].tagName.toUpperCase() !== 'details'.toUpperCase()) {
            throw new Error('You cannot enhance a ' + $el.context.tagName + ' tag, just details tags are allowed.');
        }

        // Creating div tag to replace incoming 'details' tag
        $expandableAreaDivTag = $('<div>');
        $.each($el[0].attributes, function() {
            $expandableAreaDivTag.attr(this.name, this.value);
        });
        $expandableAreaDivTag.addClass('expandable_area');
        $expandableAreaDivTag = $el.wrap($expandableAreaDivTag).parent();
        $el.contents().unwrap();

        // Is <summary> tag present?
        $summaryElement = $expandableAreaDivTag.find('summary');
        $rootWrapperDiv = null;
        $toggleAreaDivWrapper = null;
        if ($summaryElement.length > 0) {
            // Creating root wrapper div
            $rootWrapperDiv = $('<div>');

            // Creating toggle area div wrapper
            $toggleAreaDivWrapper = $('<div>');
            $toggleAreaDivWrapper.addClass('expandable_toggle_area');
            $toggleAreaDivWrapper = $summaryElement.wrap($toggleAreaDivWrapper).parent();
            $summaryElement.contents().unwrap();

            // Moving summary content to wrapperDiv
            $rootWrapperDiv = $expandableAreaDivTag.wrap($rootWrapperDiv).parent();
            $rootWrapperDiv.prepend($toggleAreaDivWrapper);

            isSummaryTagPresent = true;
        } else {
            $rootWrapperDiv = $expandableAreaDivTag;
        }

        $rootWrapperDiv.addClass('expandable_root_wrapper');

        // To prevent aditional enhancements
        $expandableAreaDivTag.attr({'data-skip-enhance': true});

        properties = {
            // An expandable element is collapsed by default
            visible: Odigeo._.isUndefined($expandableAreaDivTag.attr(ATTR_OPEN)) ? false : true,
            enabled: options.enabled,
        };

        // Function for to expand/collapse expandable area
        var _toggleVisibility = function() {
            if (!properties.visible && properties.enabled) {
                _show();
            } else {
                _hide();
            }
        };
        // Function for to collapse expandable area
        var _hide = function() {
            properties.visible = false;
            $expandableAreaDivTag.attr(ATTR_OPEN, properties.visible);
            $expandableAreaDivTag.addClass('hidden');
            if (isSummaryTagPresent === true) {
                $($expandableAreaDivTag).closest('.scroll_area').trigger('updateDimensions');
            }
        };
        // Function for to collapse expandable area
        var _show = function() {
            if (!properties.enabled) {
                return;
            }

            properties.visible = true;
            $expandableAreaDivTag.attr(ATTR_OPEN, properties.visible);
            $expandableAreaDivTag.removeClass('hidden');
            if (isSummaryTagPresent === true) {
                $($expandableAreaDivTag).closest('.scroll_area').trigger('updateDimensions');
            }
            if (Odigeo._.isFunction(showCallback) ) {
                showCallback();
            }
        };

        var _setEnabled = function(enabled) {
            properties.enabled = enabled;
        };

        // ... and applying them.
        if (properties.visible === true) {
            _show();
        } else {
            _hide();
        }

        // Bindings ...
        // ... summary bindings
        if (options.selfClose && !Odigeo._.isNull($toggleAreaDivWrapper)) {
            $toggleAreaDivWrapper.on(Odigeo.Events.tap, _toggleVisibility);
        }

        $expandableAreaDivTag
            .on('showExpandable', Odigeo._.bind(_show, this))
            .on('hideExpandable', Odigeo._.bind(_hide, this))
            .on('toggleExpandable', Odigeo._.bind(_toggleVisibility, this))
            .on('enable', Odigeo._.bind(_setEnabled, this, true))
            .on('disable', Odigeo._.bind(_setEnabled, this, false));

        return $rootWrapperDiv;
    };
}());
